import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-scroll";
// import { Link } from "react-router-dom";

function HeroSectionComponents() {
  return (
    <section
      id="home"
      className="login-wrapper py-5 min-vh-100 d-flex align-items-center"
    >
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="text-lg-start text-center"></Col>
          <Col lg={6} className="text-lg-end text-center">
            <h1 className=" landing-page-heading  display-4 fw-bold mb-4 animate__animated animate__fadeInUp ">
              Your Gateway to{" "} 
              <span className="text-primary ">Multiple AI Models</span>
            </h1>
            <p className="landing-page-text lead mb-4 animate__animated animate__fadeInUp animate__delay-1s">
              Access ChatGPT, Gemini, Mistral, Web Search, and AI Art Generation
              all in one powerful platform. Maximize your AI potential with
              AskLMS.
            </p>
            {/* <div className="d-flex justify-content-lg-start justify-content-center gap-3 animate__animated animate__fadeInUp animate__delay-2s">
              <Button
                as={Link}
                to="/login"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                variant="primary"
                size="lg"
                className="btn-cta rounded-pill px-4"
              >
                Start for Free
              </Button>
              <Button
                as={Link}
                to="models"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                variant="outline-light"
                size="lg"
                className="rounded-pill px-4"
              >
                Explore Models
              </Button>
            </div> */}
          </Col>
          {/* <Col
            lg={6}
            className="mt-5 mt-lg-0 text-center animate__animated animate__fadeIn animate__delay-1s"
          >
            <svg viewBox="0 0 600 400" width="100%" height="auto">
           
              <rect
                x="100"
                y="100"
                width="400"
                height="200"
                rx="20"
                fill="none"
                stroke="#007bff"
                strokeWidth="2"
              ></rect>
              <circle
                cx="300"
                cy="200"
                r="80"
                fill="none"
                stroke="#007bff"
                strokeWidth="3"
              ></circle>
              <path
                d="M220 200 A80,80 0 0,1 380,200"
                fill="none"
                stroke="#007bff"
                strokeWidth="3"
              ></path>
              <path
                d="M220 200 A80,80 0 0,0 380,200"
                fill="none"
                stroke="#6610f2"
                strokeWidth="3"
              ></path>

              <circle cx="180" cy="140" r="15" fill="#007bff"></circle>
              <circle cx="220" cy="260" r="15" fill="#6f42c1"></circle>
              <circle cx="380" cy="260" r="15" fill="#d63384"></circle>
              <circle cx="420" cy="140" r="15" fill="#0dcaf0"></circle>

            
              <line
                x1="195"
                y1="140"
                x2="285"
                y2="180"
                stroke="#007bff"
                strokeWidth="2"
              ></line>
              <line
                x1="235"
                y1="260"
                x2="285"
                y2="220"
                stroke="#6f42c1"
                strokeWidth="2"
              ></line>
              <line
                x1="365"
                y1="260"
                x2="315"
                y2="220"
                stroke="#d63384"
                strokeWidth="2"
              ></line>
              <line
                x1="405"
                y1="140"
                x2="315"
                y2="180"
                stroke="#0dcaf0"
                strokeWidth="2"
              ></line>

              // Pulsing animation 
              <circle cx="300" cy="200" r="30" fill="rgba(0,123,255,0.3)">
                <animate
                  attributeName="r"
                  values="30;40;30"
                  dur="2s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="opacity"
                  values="0.3;0.7;0.3"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
}

export default HeroSectionComponents;
